import React from 'react';
import PropTypes from 'prop-types';
import Auth from '@Services/Auth';
import { FEATURES } from '@Constants/rx-ui/constants';
import GroupSingleDatabase from '@Containers/ResultsPreview/GroupSingleDatabase';
import GroupMultipleDatabases from '@Containers/ResultsPreview/GroupMultipleDatabases';

import './ResultsPreview.scss';

function ResultsPreview({
  cancelQuery,
  cancelQueriesInGroup,
  previewItems,
  showMoreResults,
  showStructurePopup,
  copyQuery,
  createAlert,
  redirectToResults,
}) {
  const bioactivityVisualizationButtonEnabled = Auth.isFeatureEnabled(FEATURES.enableBioactivityVisualizationButtonOnPreviewResults);

  return (
    <div
      id="main-content"
      className="quick-results-preview results-preview e2e-quick-results-container"
      aria-label="Quick Search Results List"
      role="search">
      {previewItems.map((previewItem, previewItemIndex) =>
        previewItem.multipleDatabases ? (
          <GroupMultipleDatabases
            key={previewItem.queryId}
            previewItem={previewItem}
            showMoreResults={showMoreResults}
            showStructurePopup={showStructurePopup}
            copyQuery={copyQuery}
            createAlert={createAlert}
            redirectToResults={redirectToResults}
            cancelQuery={cancelQuery}
            cancelQueriesInGroup={cancelQueriesInGroup}
            expandedByDefault={previewItemIndex === 0}
          />
        ) : (
          <GroupSingleDatabase
            key={previewItem.queryId}
            previewItem={previewItem}
            previewItemIndex={previewItemIndex}
            showMoreResults={showMoreResults}
            bioactivityVisualizationButtonEnabled={bioactivityVisualizationButtonEnabled}
            showStructurePopup={showStructurePopup}
            copyQuery={copyQuery}
            createAlert={createAlert}
            redirectToResults={redirectToResults}
            cancelQueriesInGroup={cancelQueriesInGroup}
          />
        )
      )}
    </div>
  );
}

ResultsPreview.propTypes = {
  cancelQuery: PropTypes.func.isRequired,
  cancelQueriesInGroup: PropTypes.func.isRequired,
  previewItems: PropTypes.array.isRequired,
  showMoreResults: PropTypes.func.isRequired,
  showStructurePopup: PropTypes.func.isRequired,
  copyQuery: PropTypes.func.isRequired,
  createAlert: PropTypes.func.isRequired,
  redirectToResults: PropTypes.func.isRequired,
};

export default ResultsPreview;
